import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconAlertOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="M23.806 20.369c.55.946-.138 2.131-1.24 2.131H1.434c-1.102 0-1.79-1.185-1.24-2.131L10.76 2.21a1.438 1.438 0 0 1 2.48 0zM12 3.062 1.562 21h20.876zM12 18a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-.75-3.748V9.748c0-.408.336-.748.75-.748.417 0 .75.335.75.748v4.504A.75.75 0 0 1 12 15a.747.747 0 0 1-.75-.748" /></svg>
);
